/**
 * KitRailSection -- the RECORD-PAGE archetype's counted, expand-in-place rail
 * section (zone 5 building block).
 *
 * Law homes (cited, never re-derived here):
 *  - RECORD-PAGE archetype, zone 5 COUNTED EXPAND-IN-PLACE RIGHT RAIL:
 *    ALL-CAPS header + honest count + a right chevron, collapsed-by-default
 *    counted disclosure that expands IN PLACE (a reveal, never a navigation).
 *    docs/design/design-language/07-BEHAVIOURAL-LAWS.md ("### ARCH", UPDATE 2,
 *    zone 5). The per-state ORDER of the sections stays each surface's OWN
 *    call, cited from its own approved pack -- this kit provides only the ONE
 *    section shape, never the ordering.
 *  - The S4 SECTION-CONTAINER signature + count rule (the body's enumerable
 *    evidence items are counted; supplementary strips ride the header stat,
 *    never the count).
 *  - ANNOTATION-LAYER RIDER (07 "### ARCH" UPDATE 2): mockup annotation boxes
 *    are instruction-layer and are NEVER rendered as UI.
 *
 * REUSE, NEVER FORK: this composes the ONE shared disclosure primitive
 * (ui/SectionContainer, itself a thin signature wrapper over SectionBand's
 * native <details>/<summary>). The ALL-CAPS rail styling is the host page's
 * own `.lead-rail`-scoped CSS, not a second component -- so five other
 * surfaces that use SectionContainer keep their existing header unchanged.
 * Data arrives via props; this component fetches nothing.
 */
import SectionContainer, {
  type SectionContainerProps,
} from '@/dashboard/ui/SectionContainer';

export type KitRailSectionProps = SectionContainerProps;

export default function KitRailSection(props: KitRailSectionProps): JSX.Element {
  return <SectionContainer {...props} />;
}
